// Material-UI Imports

// Custom Imports
import { useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useAuth, useCompany } from 'hooks';
import API from 'services/AxiosConfig';
// import { toast } from 'react-toastify';
// import { generateUrl } from 'lib';
// import parse from 'html-react-parser';
import EntryTable from '../Admin/EntryTable';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import Analytic from '../Analytic';
import Search from './UserManagement/Search';
import { Add } from 'iconsax-react';

export default function Entry(secname: any,) {
    const name = secname?.name;
    const buttonTitle = secname?.buttonTitle;
    const url = secname?.url;
    const title = secname?.title;
    const objkey = secname?.objkey;
    // const filter = secname?.filter;
    const [filter, setFilter]: any = useState({
        status: { value: 'Active', label: 'Active' }
    });
    //const { locations } = useCompany()
    const { user } = useAuth();
    const [loading, setLoading] = useState<boolean>(true);
    const [rows, setRows]: any[] = useState([]);
    //const [type, setType] = useState('Active');
    const [isOpen, setIsOpen] = useState(false);
    const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    const handleOpen = () => {
        setIsOpen(true);
    }
    const generateRows = (data: any, objkey: any) => {
        return data.map((rowObj: any) => ({
            id: rowObj._id,
            name: rowObj[objkey],
            award: { value: rowObj[objkey] || 'hello', style: { width: '75%' } },
        }));
    }
    useEffect(() => {
        if (user) {
            fetchData();
        }
    }, [name, filter]);

    const fetchData = (d = false) => {
        setLoading(true)
        const isReferral = title !== 'Prospect Activity'
        let u = `${url}/activity/search/${filter.status.value}?referral=${isReferral}`
        API.get(u)
            .then(({ data }) => {
                setRows(generateRows(data.data, objkey));
                setLoading(false);
                if (d === true) {
                    doRefresh();
                }
            })
    }
    const { refreshRatings, refreshCompanyRatings, refreshactivityTypes, refreshCompanyTypes } = useCompany();
    const doRefresh = () => {
        console.log("do refresh calling---" + url)
        if (url === 'rating-referral') {
            refreshRatings();
        }
        else if (url === 'rating-referral-company') {
            refreshCompanyRatings();
        }
        else if (url === 'marketing/type') {
            refreshactivityTypes();
        }
        else if (url === 'referral-partners') {
            refreshCompanyTypes();
        }
    };
    return (
        <>
            <Analytic />
            <br></br>
            <div className="heading">
                <Typography variant="h1">{name}</Typography>
                {isSmallScreen && <Button
                    variant="contained"
                    startIcon={!isSmallScreen && <Add />}
                    onClick={handleOpen}
                    sx={{ width: isSmallScreen ? "150px" : "auto" }}
                    className="common-button"
                >{buttonTitle}</Button>}
            </div>
            <br></br>
            <Search filter={filter} setFilter={setFilter} isManagement={true} />
            <EntryTable rows={rows} loading={loading} getData={fetchData} buttonTitle={buttonTitle} url={url} userId={user?._id} type={filter.status.value} setData={setRows} isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    );
}
